import React, {useEffect, useState} from "react";
import FormControl from "react-bootstrap/FormControl";
import isEmpty from "lodash/isEmpty";
import Table from "react-bootstrap/Table";

const pad = (n) => String(n).padStart(2, '0');
// date-fns format('yyyy-MM-dd HH:mm:ss') 相当。撤去のため自前で実装。
const formatDateTime = (input) => {
    const d = new Date(input);
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
        `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};

export const DebugLogViewer = ({users}) => {
    const [userId, setUserId] = useState(users[0]?.id.toString() || '');
    const [logs, setLogs] = useState([]);
    useEffect(() => {
        if (!isEmpty(userId)) {
            console.log("User ID changed:", userId);
            fetch(`/admin/debug_logs/api?user_id=${userId}`).then(r => r.json()).then(setLogs);
        }
    }, [userId]);
    return <>
        <FormControl as="select" onChange={e => setUserId(e.target.value)}>
            {
                users.map((user) => <option key={`user-select-${user.id}`} value={user.id}>{user.name}</option>)
            }
        </FormControl>
        <Table className="mt-4">
            <tbody>
                {
                    logs.map((log) => (
                        <tr key={`user-row-${log.id}`}>
                            <td style={{minWidth: 120}}>{formatDateTime(log.created_at)}</td>
                            <td>{log.tag}</td>
                            <td style={{minWidth: 100}}>{log.label}</td>
                            <td>{JSON.stringify(log.value)}</td>
                        </tr>
                    ))
                }
            </tbody>
        </Table>
    </>;
};